import * as React from "react";
const SvgPaymentLinkIcon = () => (
  <svg width={24} height={24} fill="none">
    <path
      fill="#6366F1"
      d="M15.19 5.145c1.186-1.172 2.922-1.197 3.883-.248.963.952.938 2.671-.25 3.844l-2.006 1.98a.605.605 0 0 0 .009.857.626.626 0 0 0 .87.006l2.006-1.981c1.581-1.563 1.78-4.057.25-5.568-1.53-1.512-4.06-1.315-5.644.248l-4.01 3.963c-1.581 1.562-1.78 4.056-.25 5.567a.622.622 0 0 0 .68.142.624.624 0 0 0 .34-.333.602.602 0 0 0-.141-.67c-.963-.952-.937-2.672.25-3.844l4.012-3.963Z"
    />
    <path
      fill="#6366F1"
      d="M13.953 10.18a.626.626 0 0 0-.879-.002.607.607 0 0 0 0 .865c.962.952.937 2.672-.252 3.846l-4.01 3.964c-1.188 1.174-2.924 1.198-3.885.248-.963-.952-.937-2.672.25-3.845l2.007-1.983a.611.611 0 0 0 .18-.432.603.603 0 0 0-.182-.432.623.623 0 0 0-.677-.131.62.62 0 0 0-.201.133l-2.006 1.982c-1.581 1.564-1.78 4.059-.25 5.57 1.53 1.515 4.06 1.317 5.643-.247l4.011-3.965c1.582-1.563 1.78-4.06.25-5.571Z"
    />
  </svg>
);
export default SvgPaymentLinkIcon;
